module.exports = __webpack_public_path__ + "static/media/pla_bur_hot_lan.d389de1f.png";